import { DEFAULT_ACTIVE_HURRICANES_SOURCE } from 'hooks/orgEvents/orgEventAutomationHooks';
import type { ExternalLayerAccessType } from 'hooks/externalLayer/types';

export type DemoArcGisLayer = {
  id: string;
  name: string;
  description: string;
  serviceUrl: string;
  authType: ExternalLayerAccessType;
  /** When true, schema comes from fixtures only (no live ArcGIS call). */
  mockOnly?: boolean;
};

/**
 * Curated public AGOL layers so a prospect can build a rule with zero ArcGIS
 * auth. Schema + preview counts are live against these URLs.
 */
export const DEMO_ARCGIS_LAYER_CATALOG: DemoArcGisLayer[] = [
  {
    id: 'demo-nws-watches-warnings',
    name: 'NWS Watches and Warnings',
    description:
      'National Weather Service active watches, warnings, and advisories.',
    serviceUrl:
      'https://services9.arcgis.com/RHVPKKiFTONKtxq3/arcgis/rest/services/NWS_Watches_Warnings_v1/FeatureServer/6',
    authType: 'public',
  },
  {
    id: 'demo-active-hurricanes-cone',
    name: 'Active Hurricanes forecast cone',
    description:
      'NHC forecast cone polygons (same feed as the tropical preset).',
    serviceUrl: DEFAULT_ACTIVE_HURRICANES_SOURCE.serviceUrl,
    authType: 'public',
  },
  {
    id: 'demo-private-ops-status',
    name: 'Private Ops Status (offline demo)',
    description:
      'Mock private layer with coded Status + Priority range — no ArcGIS call.',
    serviceUrl:
      'https://mock.pratus.local/arcgis/rest/services/PrivateOpsStatus/FeatureServer/0',
    authType: 'userAuth',
    mockOnly: true,
  },
];

export function findDemoLayerByUrl(
  serviceUrl: string | null | undefined
): DemoArcGisLayer | undefined {
  if (!serviceUrl) return undefined;
  const normalized = serviceUrl.trim().replace(/\/+$/, '');
  return DEMO_ARCGIS_LAYER_CATALOG.find(
    (layer) => layer.serviceUrl.replace(/\/+$/, '') === normalized
  );
}
